var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath1106(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.253,
    height: 28.703,
    viewBox: "0 0 18.253 28.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M20.653,1.013,7.606,1a2.606,2.606,0,0,0-2.6,2.609V27.094a2.606,2.606,0,0,0,2.6,2.609H20.653a2.617,2.617,0,0,0,2.609-2.609V3.609A2.606,2.606,0,0,0,20.653,1.013Zm0,23.472H7.606V6.219H20.653Z",
    transform: "translate(-5.01 -1)",
    fill: "#f1f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1106);
export default __webpack_public_path__ + "static/media/Path 1106.2acfe2d5de2fda644da7859baaab26b9.svg";
export { ForwardRef as ReactComponent };